import React, { Fragment, useState } from 'react'
import { faAngleRight, faAngleLeft, faEquals, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import G from '../../util/globalFunction'

export default props => {
    const {
        menu: { menus },
    } = props
    const [currentMenu, setCurrentMenu] = useState(null)
    const [unfold, setUnfold] = useState(true)

    const handleCloseClick = e => {
        e.preventDefault()
        setUnfold(!unfold)
    }

    return (
        <div className="hidden md:block">
            <div
                className="bg-white h-full w-full flex flex-col cursor-pointer"
                style={{ width: unfold ? 200 : 36 }}
            >
                <div className="flex-grow overflow-y-auto">
                    {unfold &&
                        menus.map((menu, index) => {
                            const { title, menus } = menu

                            return (
                                <Fragment key={index}>
                                    <div
                                        key={index}
                                        className={`border-b border-gray-300 p-4 flex flex-row items-center ${
                                            currentMenu && currentMenu.title === title
                                                ? 'bg-blue-900 text-white'
                                                : 'bg-white'
                                        }`}
                                        style={{ height: 50 }}
                                        onClick={e => {
                                            e.preventDefault()
                                            setCurrentMenu(currentMenu === menu ? null : menu)
                                        }}
                                    >
                                        <span className="flex-grow text-sm">{title}</span>
                                        <div className="flex-none">
                                            <FontAwesomeIcon
                                                icon={
                                                    currentMenu && currentMenu.title === title
                                                        ? faEquals
                                                        : faPlus
                                                }
                                                size="sm"
                                            />
                                        </div>
                                    </div>
                                    {currentMenu === menu && menus && (
                                        <div className="text-sm bg-gray-200 pl-4 p-2">
                                            {menus.map(({ title, route }, index) => (
                                                <div
                                                    className="flex flex-row gap-4 h-8 items-center"
                                                    key={index}
                                                    onClick={e => {
                                                        e.preventDefault()
                                                        G.gotoPage(route)
                                                    }}
                                                >
                                                    <span>▪</span>
                                                    <span>{title}</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </Fragment>
                            )
                        })}
                </div>

                <div
                    className="flex-none border-t border-gray-300 flex justify-end cursor-pointer font-sm font-gray-900 py-1 px-3"
                    onClick={handleCloseClick}
                >
                    <FontAwesomeIcon icon={unfold ? faAngleLeft : faAngleRight} size="lg" />
                </div>
            </div>
        </div>
    )
}
